import { createSlice } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import {
  abhaAddOtpThunk,
  abhaSearchThunk,
  abhaVerifyOtpThunk,
  mobileAbhaSearchThunk,
  mobileOtpThunk,
  verifyOtpThunk,
} from "./thunk";

const mobileOtpInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const mobileOtpSlice = createSlice({
  name: "mobileOtp",
  initialState: mobileOtpInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(mobileOtpThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(mobileOtpThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(mobileOtpThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const verifyOtpInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const verifyOtpSlice = createSlice({
  name: "verifyOtp",
  initialState: verifyOtpInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyOtpThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(verifyOtpThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(verifyOtpThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const mobileAbhaSearchInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const mobileAbhaSearchSlice = createSlice({
  name: "mobileAbhaSearch",
  initialState: mobileAbhaSearchInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(mobileAbhaSearchThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(mobileAbhaSearchThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(mobileAbhaSearchThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const abhaSearchInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const abhaSearchSlice = createSlice({
  name: "abhaSearch",
  initialState: abhaSearchInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(abhaSearchThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(abhaSearchThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(abhaSearchThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const abhaAddOtpInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const abhaAddOtpSlice = createSlice({
  name: "abhaAddOtp",
  initialState: abhaAddOtpInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(abhaAddOtpThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(abhaAddOtpThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(abhaAddOtpThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});
const abhaVerifyOtpInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const abhaVerifyOtpSlice = createSlice({
  name: "abhaVerifyOtp",
  initialState: abhaVerifyOtpInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(abhaVerifyOtpThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(abhaVerifyOtpThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(abhaVerifyOtpThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

export const { reset: resetMobileOtp } = mobileOtpSlice.actions;
export const { reset: resetVerifyOtp } = verifyOtpSlice.actions;
export const { reset: resetMobileAbhaSearch } = mobileAbhaSearchSlice.actions;
export const { reset: resetAbhaSearch } = abhaSearchSlice.actions;
export const { reset: resetAbhaAddOtp } = abhaAddOtpSlice.actions;
export const { reset: resetAbhaVerifyOtp } = abhaVerifyOtpSlice.actions;

const reducers = combineReducers({
  mobileOtp: mobileOtpSlice.reducer,
  verifyOtp: verifyOtpSlice.reducer,
  mobileAbhaSearch: mobileAbhaSearchSlice.reducer,
  abhaSearch: abhaSearchSlice.reducer,
  abhaAddOtp: abhaAddOtpSlice.reducer,
  abhaVerifyOtp: abhaVerifyOtpSlice.reducer,
});

export default reducers;
